import { COS } from '@cssat/acorn-api-shared';
import { authenticatedFetch, paths } from 'lib';
import useSWR from 'swr';

export const useCosByChildId = (childId: string) =>
  useSWR<COS[]>(paths.cos.listByChildId({ childId }), authenticatedFetch);
